"use strict";

exports.__esModule = true;
exports.default = void 0;

var _baseCss = _interopRequireDefault(require("./base.css.js"));

var _fontCss = _interopRequireDefault(require("./font.css.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = "\n  " + _baseCss.default + "\n  " + _fontCss.default + "\n";

exports.default = _default;